import styled, { css } from "styled-components";

const BodyContainer = styled.div`
    padding: 0 15px 20px;
    background-color: #fff;
    margin: 30px 0 30px;

    .product-details__slider,
    .product-details__details {
        width: 100%;
    }

    ${(props) =>
        props.theme &&
        css`
            @media (min-width: 850px) {
                .product-details__slider {
                    padding-right: 50px;
                    width: calc(100% - 350px);
                }

                .product-details__details {
                    width: 350px;
                }
            }
        `}

    ${(props) =>
        props.theme &&
        css`
            @media (min-width: 1200px) {
                .product-details__slider {
                    padding-right: 50px;
                    width: calc(100% - 550px);
                }

                .product-details__details {
                    width: 550px;
                }
            }
        `}

    .slider-inner {
        margin: 30px 0;
        .swiper-button-prev,
        .swiper-button-next {
            color: #333;
        }
        @media (max-width: 600px) {
            margin: 0px 0 0px;
        }
        .thumb-slider,
        .main-slider {
            display: inline-block;
            vertical-align: top;
        }
        .thumb-slider {
            width: 100px;
            @media (max-width: 600px) {
                width: 55px;
                // display: none !important;
            }
            > .inner {
            }
            .thumb-item {
                height: 100px;
                width: 100%;
                cursor: pointer;
                border: 2px solid rgb(236, 236, 236);
                padding: 2px;
                &:not(:last-child) {
                    > .img-view {
                        margin-bottom: 10px;
                    }
                }
                @media (max-width: 600px) {
                    height: 55px;
                }
                img {
                    max-width: 100%;
                    max-height: 100%;
                    width: auto;
                }
                &:hover {
                    border-color: #333;
                }
            }
            .slick-current .thumb-item {
                border-color: #333;
            }
        }

        .main-slider {
            width: calc(100% - 100px);
            padding-left: 15px;
            @media (max-width: 600px) {
                width: calc(100% - 55px);
                padding-left: 10px;
            }

            .img-view {
                min-height: 300px;
            }
        }
    }

    .product-page-variation-viewer {
        .item {
            &:not(:last-child) {
                // margin-right: 15px;
            }
            > .rectangles-list > label {
                margin-bottom: 15px;
                &:not(:last-child) {
                    margin-right: 15px;
                }
            }
        }
    }
    // st form rectangle
    .st-form-rectangle {
        cursor: pointer;
        .rect {
            display: block;
            padding: 7px 15px;
            border: 2px solid #efefef;
        }

        > input {
            &:checked {
                + .rect {
                    border-color: #000;
                    background-color: #000;
                    color: #fff;
                    pointer-events: none;
                }
            }
        }

        &.matched {
            .rect {
                border-color: #aaaaaa;
            }
        }
        &.unmatched {
            .rect {
                border-color: #efefef;
                color: #bcbcbc;
            }
        }
        &[data-checked="checked"] {
            // pointer-events: none;
        }

        .icon {
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-size: 22px;
            color: #717171;
        }
    }
    .add-to-bag-btn {
        margin-bottom: 20px;
        button {
            padding: 13px 10px 12px;
            font-size: 18px;
            font-weight: 600;
            &:hover {
                box-shadow: none;
                background-color: #333;
            }
        }
    }

    .img-view {
        &:not(.loaded) {
            background: #efefef;
            img {
                opacity: 0;
            }
        }
    }

    .slick-track {
        height: auto !important;
    }
    .slick-prev,
    .slick-next {
        z-index: 1;
    }
    .slick-prev:before,
    .slick-next:before {
        color: #333;
        font-size: 25px;
    }
    .slick-prev {
        left: 10px;
    }
    .slick-next {
        right: 10px;
    }

    .call-for-price-message {
        > p {
            background: #efefef;
            border-left: 2px solid #333;
            padding: 6px 10px 5px;
            // font-weight: 600;
        }
    }
`;
export default BodyContainer;
